import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireAdminFeature } from "@/middleware/admin-feature-guard";

/**
 * Layout sub menu "Log Percakapan": satu guard untuk daftar pengguna, detail
 * pengguna, dan transkrip. Isi transkrip masih butuh izin terpisah
 * (`read-assistant-transcript`) yang diperiksa di server.
 */
export const Route = createFileRoute("/admin/ai-assistant/log")({
	beforeLoad: requireAdminFeature("admin-ai-log"),
	component: Outlet,
});
